export default "__VITE_ASSET__Bxws5cGn__"